import React, { useEffect, useState, createContext, useContext } from 'react';
type Language = 'en' | 'ru' | 'ua' | 'cz';
type LanguageContextType = {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
  getPath: (path: string) => string;
  navigate: (path: string) => void;
};
const translations = {
  cz: {
    // Navigation
    'nav.getStarted': 'Konzultace zdarma',
    'nav.home': 'Domů',
    'nav.services': 'Ceník',
    'nav.howItWorks': 'Jak to funguje',
    'nav.referral': 'Doporučovací program',
    'nav.privacy': 'Zásady ochrany osobních údajů',
    'nav.terms': 'Podmínky služby',
    'nav.pricing': 'Ceník',
    'nav.faq': 'Časté dotazy',
    'nav.testimonials': 'Recenze',
    // Cookie Banner
    'cookie.title': 'Používáme cookies',
    'cookie.description': 'Používáme cookies ke zlepšení vašeho zážitku na našem webu, analýze návštěvnosti a personalizaci obsahu.',
    'cookie.accept': 'Přijmout vše',
    'cookie.decline': 'Odmítnout',
    'cookie.learnMore': 'Dozvědět se více',
    // Hero - H1 tag
    'hero.badge': 'Profesionální webová agentura',
    'hero.title': 'Vytvoříme pro vás web na míru',
    'hero.titleHighlight': 'jen za 7 000 Kč',
    'hero.subtitle': 'Ukážeme vám bezplatný návrh vašeho webu. Pokud se vám nebude líbit — nic neplatíte.',
    'hero.bullet1': 'Bezplatný náhled webu před platbou',
    'hero.bullet2': '7 000 Kč — poplatek za vývoj webu, pokud se vám výsledek líbí',
    'hero.bullet3': 'Pracujeme celosvětově (plně na dálku)',
    'hero.cta': 'Konzultace zdarma',
    'hero.referral': 'Doporučovací program',
    // Pricing - H2: Pricing & terms
    'pricing.title': 'Ceník',
    'pricing.titleHighlight': '& podmínky',
    'pricing.subtitle': 'Nejprve bezplatný návrh. Platba pouze pokud vám vše vyhovuje.',
    // H3: Free website preview
    'pricing.demo.title': 'Bezplatný návrh webu',
    'pricing.demo.label': 'ZDARMA',
    'pricing.demo.desc': 'Ukážeme vám váš budoucí web před platbou.',
    'pricing.demo.b1': 'Návrh přizpůsobený vašemu podnikání',
    'pricing.demo.b2': 'Můžete požádat o změny',
    'pricing.demo.b3': 'Nelíbí se vám to — neplatíte',
    'pricing.demo.cta': 'Konzultace zdarma',
    // H3: Website development (€299 one-time)
    'pricing.launch.title': 'Vývoj webu',
    'pricing.launch.price': '7 000 Kč',
    'pricing.launch.period': '(jednorázově)',
    'pricing.launch.desc': 'Pokud vám vše vyhovuje — získáte hotový web k použití.',
    'pricing.launch.b1': 'Vlastní design',
    'pricing.launch.b2': 'Mobilní adaptace',
    'pricing.launch.b3': 'Změny na vyžádání',
    'pricing.launch.b4': 'Poptávkový formulář',
    'pricing.launch.cta': 'Konzultace zdarma',
    // How It Works - H2
    'how.title': 'Jak to',
    'how.titleHighlight': 'funguje',
    // H3 steps
    'how.step1.title': 'Řekněte nám o svém podnikání',
    'how.step1.note': 'Zabere to 2 minuty — co děláte a jaký web potřebujete',
    'how.step2.title': 'Vytvoříme bezplatný náhled webu',
    'how.step2.note': 'Ukážeme design a strukturu. Odkaz získáte za 1–3 dny',
    'how.step3.title': 'Řeknete nám, co změnit',
    'how.step3.note': 'Text, sekce, styl — vše aktualizujeme',
    'how.step4.title': 'Až budete s webem spokojeni, zaplatíte 7 000 Kč',
    'how.step4.note': 'Platba až poté, co řeknete: "Ano, to mi vyhovuje"',
    'how.step5.title': 'Připojíme vaši doménu a zveřejníme web',
    'how.step5.note': 'Váš web bude spuštěn a začne sbírat poptávky.',
    'how.note': 'Pokud se vám web nelíbí — neplatíte.',
    // FAQ - H2: Frequently Asked Questions
    'faq.title': 'Časté',
    'faq.titleHighlight': 'dotazy',
    'faq.subtitle': 'Vše, co potřebujete vědět o spolupráci s naším týmem',
    // H3 questions
    'faq.q1': 'Co je to bezplatný návrh?',
    'faq.a1': 'Je to předběžná verze vašeho webu před platbou.',
    'faq.q2': 'Kdy platím 7 000 Kč?',
    'faq.a2': 'Pouze pokud vám návrh vyhovuje a chcete web spustit.',
    'faq.q3': 'Mohu požádat o změny?',
    'faq.a3': 'Ano, před spuštěním můžeme provést změny.',
    'faq.q4': 'Co dostanu po zaplacení?',
    'faq.a4': 'Hotový web pro vaše podnikání.',
    'faq.q5': 'Pracujete celosvětově?',
    'faq.a5': 'Ano, pracujeme online s klienty z různých zemí.',
    // Testimonials - H2: What clients say
    'testimonials.title': 'Klientské',
    'testimonials.titleHighlight': 'recenze',
    'testimonials.subtitle': 'Co říkají klienti o spolupráci s námi',
    'testimonials.r1.name': 'Sarah',
    'testimonials.r1.text': 'Líbilo se mi, že mi nejprve ukázali web zdarma. Požádala jsem o pár změn, vše bylo rychle opraveno. Platila jsem až když bylo vše perfektní.',
    'testimonials.r1.business': 'Kosmetička',
    'testimonials.r2.name': 'Alex',
    'testimonials.r2.text': 'Udělali mi přehledný web pro mé služby. Nejprve mi ukázali návrh, pak provedli změny. Platil jsem až po potvrzení.',
    'testimonials.r2.business': 'Hodinový manžel',
    'testimonials.r3.name': 'James',
    'testimonials.r3.text': 'Je pohodlné, že nemusíte platit předem. Nejprve jsem se podíval na web, požádal o zjednodušení textu a pak zaplatil. Vše je spravedlivé a jasné.',
    'testimonials.r3.business': 'Psycholog',
    // Consultation - H2: Get your free preview
    'consultation.title': 'Objednejte si bezplatnou',
    'consultation.titleHighlight': 'konzultaci',
    'consultation.subtitle': 'Řekněte nám, co potřebujete — pošleme vám odkaz na náhled.',
    'consultation.benefit1': 'Náhled zdarma',
    'consultation.benefit2': 'Rychlé dodání',
    'consultation.benefit3': 'Bez závazků',
    'consultation.name': 'Jméno',
    'consultation.namePlaceholder': 'Vaše jméno',
    'consultation.email': 'E-mail',
    'consultation.emailPlaceholder': 'vas@email.cz',
    'consultation.desc': 'Popis projektu',
    'consultation.descPlaceholder': 'Řekněte nám o svém podnikání a jaký web potřebujete...',
    'consultation.cta': 'Objednat konzultaci zdarma',
    'consultation.note': 'Bez závazků. Pokud se vám web nelíbí — neplatíte.',
    'consultation.sending': 'Odesílání...',
    'consultation.or': ' nebo si promluvte přímo s naším týmem',
    'consultation.telegram': 'Telegram',
    'consultation.whatsapp': 'WhatsApp',
    // Footer
    'footer.services': 'Služby',
    'footer.company': 'Společnost',
    'footer.legal': 'Právní',
    'footer.contact': 'Kontakt',
    'footer.rights': 'Všechna práva vyhrazena.',
    'footer.aboutLink': 'O Jetly',
    // Stats
    'stats.websites': 'Spuštěných webů',
    'stats.clients': 'Spokojených klientů',
    'stats.years': 'Let zkušeností',
    'stats.title': 'Náš',
    'stats.titleHighlight': 'dopad',
    'stats.subtitle': 'Přinášíme výsledky pro firmy po celém světě',
    // AI Course Page
    'course.hero.badge': 'Staňte se majitelem digitálního podniku',
    'course.hero.title': 'Kupte si IT podnikání na klíč: vlastní webové studio založené na AI',
    'course.hero.pill1': 'Bez předchozích zkušeností',
    'course.hero.pill2': 'Rychlá návratnost',
    'course.hero.pill3': 'Pracujte na sebe',
    'course.hero.socialProof': 'studentů již vydělává s AI',
    'course.hero.socialProofCount': '100+',
    'course.hero.specialPrice': 'Cena',
    'course.hero.buyCourse': 'Koupit podnikání',
    'course.recognize.title': 'Poznáváte se?',
    'course.recognize.c1.title': 'Pracujete pro někoho jiného — ale mohli byste pracovat na sebe',
    'course.recognize.c1.text': 'Každý den dáváte svůj čas a energii cizímu podnikání. Ale stále jste nezačali své vlastní.',
    'course.recognize.c2.title': 'Chcete více peněz — ale nevíte jak',
    'course.recognize.c2.text': 'Váš plat neroste. Práce na volné noze se zdá děsivá. Máte pocit, že vydělávání peněz online vyžaduje speciální znalosti.',
    'course.recognize.c3.title': 'Myslíte si, že IT není pro vás',
    'course.recognize.c3.text': 'Kód, vývoj, technologie — zní to složitě. Máte pocit, že je to jen pro ty, kteří studovali roky.',
    'course.recognize.c4.title': 'Vidíte ostatní vydělávat — a vám to uniká',
    'course.recognize.c4.text': 'AI již změnila trh. Ti, kteří se zapojili brzy, již vydělávají. Vy stále přemýšlíte.',
    'course.offer.title': 'Co nabízíme?',
    'course.offer.tag1': 'Podnikání na klíč',
    'course.offer.tag2': 'Vhodné i pro začátečníky',
    'course.offer.heading': 'Koupit IT podnikání na klíč',
    'course.offer.description': 'Systém, který za vás vytváří weby. Vy popíšete úkol — AI vytvoří prototyp struktury, nakreslí design a napíše hotový kód.',
    'course.offer.tagline1': 'Jedno aktivum, které otevírá nový zdroj příjmů.',
    'course.offer.tagline2': 'Žádné zkušenosti, žádný kód — jen vy a AI.',
    'course.offer.feature1': 'Web IT agentury',
    'course.offer.feature2': 'AI agent pro prototypování a design',
    'course.offer.feature3': 'AI agent pro kódování a rozvržení',
    'course.offer.feature4': 'Průvodce krok za krokem pro práci se systémem',
    'course.offer.feature5': 'Doživotní technická podpora',
    'course.offer.price': '€9 500',
    'course.offer.priceLabel': '',
    'course.offer.priceDescription': 'Vše, co potřebujete k zahájení tvorby a prodeje webů.',
    'course.offer.cta': 'Koupit podnikání',
    'course.calc.title': 'Kolik můžete vydělat vytvářením webů pomocí AI?',
    'course.calc.priceLabel': 'Za kolik jste ochotni prodat web?',
    'course.calc.sitesLabel': 'Kolik webů měsíčně chcete dělat?',
    'course.calc.potentialIncome': 'VÁŠ POTENCIÁLNÍ PŘÍJEM',
    'course.calc.perMonth': '/ měsíc',
    'course.calc.coursePrice': 'Cena podnikání',
    'course.calc.payback': 'Návratnost',
    'course.calc.paybackValue': '',
    'course.calc.netProfit': 'Čistý zisk (1. měsíc)',
    'course.testimonials.title': 'Recenze studentů',
    'course.testimonials.subtitle': 'Co říkají ti, kteří již absolvovali relaci',
    'course.faq.title': 'Časté dotazy',
    'course.faq.subtitle': 'Vše, co potřebujete vědět o podnikání na klíč',
    'course.faq.q1': 'Potřebuji zkušenosti v IT nebo vývoji?',
    'course.faq.a1': 'Ne. Systém je plně automatizovaný — popíšete úkol, AI udělá design a kód. Žádné programování, žádná Figma.',
    'course.faq.q2': 'Co přesně dostanu po zakoupení?',
    'course.faq.a2': 'Hotový web agentury, dva AI agenty pro tvorbu designu a kódování, průvodce krok za krokem pro práci se systémem a doživotní technickou podporu.',
    'course.faq.q3': 'Jak dlouho trvá vytvoření jednoho webu?',
    'course.faq.a3': 'Od 30 minut do několika hodin v závislosti na složitosti. AI udělá většinu práce — vy musíte jen zkontrolovat výsledek.',
    'course.faq.q4': 'Mohu vidět, jak systém funguje před nákupem?',
    'course.faq.a4': 'Ano. Přihlaste se na bezplatnou konzultaci — ukážeme vám demo a odpovíme na všechny otázky.',
    'course.faq.q5': 'Za kolik mohu prodávat weby klientům?',
    'course.faq.a5': 'Toto je zcela vaše rozhodnutí. Průměrná tržní hodnota jednostránkového webu je €450. Z naší strany neexistují žádná omezení.',
    'course.faq.q6': 'Co když nastanou technické problémy?',
    'course.faq.a6': 'Poskytujeme doživotní technickou podporu. Napište nám — pomůžeme vám vyřešit jakýkoli problém.',
    'course.faq.q7': 'Lze toto podnikání škálovat?',
    'course.faq.a7': 'Ano. Systém nemá žádné limity na počet webů. Čím více objednávek — tím větší příjem. Není třeba najímat tým.',
    'course.fear.title1': 'Zatímco pochybujete — ',
    'course.fear.title2': 'někdo již začal své digitální podnikání.',
    'course.fear.f1.fear': '«Nikdy jsem nedělal weby»',
    'course.fear.f1.reality': 'Stačí popsat, co chcete — AI udělá vše sama',
    'course.fear.f2.fear': '«Je to těžké a trvá to dlouho»',
    'course.fear.f2.reality': 'Svůj první web vytvoříte hned po první relaci',
    'course.fear.f3.fear': '«Nevím, kde najít klienty»',
    'course.fear.f3.reality': 'Každá restaurace, salon, lékař, obchod — je váš potenciální klient',
    'course.fear.f4.fear': '«Co když selžu»',
    'course.fear.f4.reality': 'Mentor je nablízku — neopustíme vás, dokud neuspějete',
    'course.cta.title': 'Jste připraveni začít podnikat?',
    'course.cta.subtitle': 'Jedno aktivum. Neomezené weby.',
    'course.cta.btn': 'Koupit podnikání — €9 500',
    'course.cta.link': 'nebo si rezervujte bezplatnou konzultaci →',
    'course.how.title': 'Jak to',
    'course.how.titleHighlight': 'funguje',
    'course.how.step1.title': 'Popíšete úkol',
    'course.how.step1.note': 'Určete výklenek, styl a co by měl web dělat — nic jiného není potřeba',
    'course.how.step2.title': 'AI vytvoří design',
    'course.how.step2.note': 'Agent vygeneruje moderní rozvržení pro váš úkol — bez Figmy a designéra',
    'course.how.step3.title': 'AI nakóduje rozvržení',
    'course.how.step3.note': 'Druhý agent přemění rozvržení na čistý fungující web — automaticky',
    'course.how.step4.title': 'Zkontrolujete výsledek',
    'course.how.step4.note': 'Zkontrolujte web, v případě potřeby proveďte konečné úpravy',
    'course.how.step5.title': 'Dodejte klientovi — dostanete zaplaceno',
    'course.how.step5.note': 'Klient dostane hotový web, vy — peníze za práci',
    'course.testimonials.label': 'Recenze studentů',
    'course.testimonials.r1.name': 'Marina',
    'course.testimonials.r1.role': 'Na volné noze, Kyjev',
    'course.testimonials.r1.text': 'Myslela jsem, že to bude těžké. Postavila jsem svůj první web v jedné relaci a už našla klienta. Mentor vše jasně vysvětlil, žádná omáčka.',
    'course.testimonials.r2.name': 'Alexey',
    'course.testimonials.r2.role': 'Malý podnik, Varšava',
    'course.testimonials.r2.text': 'Chtěl jsem stavět weby pro své podnikání. Po relaci jsem udělal web za jeden večer. Kurz se mi okamžitě vrátil — ušetřil jsem za vývojáře.',
    'course.testimonials.r3.name': 'Dmitry',
    'course.testimonials.r3.role': 'Bez zkušeností s IT, Berlín',
    'course.testimonials.r3.text': 'Nulové zkušenosti s programováním. Po relaci jsem pochopil, jak to funguje, a nyní stavím weby pro klienty. Stojí to za každý cent.',
    // Sale Page
    'sale.timer.title': 'Časově omezená nabídka končí za:',
    'sale.timer.days': 'Dny',
    'sale.timer.hours': 'Hodiny',
    'sale.timer.minutes': 'Minuty',
    'sale.timer.seconds': 'Sekundy',
    'sale.hero.title': 'Vytvoříme pro vás web na míru',
    'sale.hero.titleHighlight': 'ZDARMA',
    'sale.hero.subtitle': 'Plaťte pouze 350 Kč/měsíc za hosting a podporu. Žádné počáteční náklady na vývoj.',
    'sale.hero.bullet1': 'Vývoj webu zdarma',
    'sale.hero.bullet2': 'Předplatné pouze 350 Kč/měsíc',
    'sale.hero.bullet3': 'Zrušení kdykoli',
    'sale.pricing.title': 'Náklady na vytvoření webu',
    'sale.pricing.titleHighlight': ' ',
    'sale.pricing.subtitle': 'Nechte si web vytvořit zdarma, plaťte jen malý měsíční poplatek.',
    'sale.pricing.launch.title': 'Používání webu',
    'sale.pricing.launch.price': '350 Kč',
    'sale.pricing.launch.period': '/ měsíc',
    'sale.pricing.launch.desc': 'Vše, co potřebujete k hladkému chodu vašeho webu.',
    // SMS Page
    'sms.timer.title': 'Časově omezená nabídka končí za:',
    'sms.timer.days': 'Dny',
    'sms.timer.hours': 'Hodiny',
    'sms.timer.minutes': 'Minuty',
    'sms.timer.seconds': 'Sekundy',
    'sms.hero.title': 'Vytvoříme pro vás web na míru',
    'sms.hero.titleHighlight': 'ZDARMA',
    'sms.hero.subtitle': 'Plaťte pouze 350 Kč/měsíc za hosting a podporu. Žádné počáteční náklady na vývoj.',
    'sms.hero.bullet1': 'Vývoj webu zdarma',
    'sms.hero.bullet2': 'Předplatné pouze 350 Kč/měsíc',
    'sms.hero.bullet3': 'Zrušení kdykoli',
    'sms.pricing.title': 'Náklady na vytvoření webu',
    'sms.pricing.titleHighlight': ' ',
    'sms.pricing.subtitle': 'Nechte si web vytvořit zdarma, plaťte jen malý měsíční poplatek.',
    'sms.pricing.launch.title': 'Používání webu',
    'sms.pricing.launch.price': '350 Kč',
    'sms.pricing.launch.period': '/ měsíc',
    'sms.pricing.launch.desc': 'Vše, co potřebujete k hladkému chodu vašeho webu.'
  },
  en: {
    // Navigation
    'nav.getStarted': 'Free consultation',
    'nav.home': 'Home',
    'nav.services': 'Pricing',
    'nav.howItWorks': 'How it works',
    'nav.referral': 'Referral Program',
    'nav.privacy': 'Privacy Policy',
    'nav.terms': 'Terms of Service',
    'nav.pricing': 'Pricing',
    'nav.faq': 'FAQ',
    'nav.testimonials': 'Reviews',
    // Cookie Banner
    'cookie.title': 'We use cookies',
    'cookie.description': 'We use cookies to improve your experience on our site, analyze traffic, and personalize content.',
    'cookie.accept': 'Accept All',
    'cookie.decline': 'Decline',
    'cookie.learnMore': 'Learn More',
    // Hero - H1 tag
    'hero.badge': 'Professional web agency',
    'hero.title': "We'll create a custom website for you",
    'hero.titleHighlight': 'for just €299',
    'hero.subtitle': "We'll show you a free mockup of your website. If you don't like it — you pay nothing.",
    'hero.bullet1': 'Free website preview before payment',
    'hero.bullet2': '€299 — website development fee if you like the result',
    'hero.bullet3': 'We work worldwide (fully remote)',
    'hero.cta': 'Free consultation',
    'hero.referral': 'Referral Program',
    // Pricing - H2: Pricing & terms
    'pricing.title': 'Pricing',
    'pricing.titleHighlight': '& terms',
    'pricing.subtitle': 'First a free mockup. Payment only if everything suits you.',
    // H3: Free website preview
    'pricing.demo.title': 'Free website mockup',
    'pricing.demo.label': 'FREE',
    'pricing.demo.desc': "We'll show you your future website before payment.",
    'pricing.demo.b1': 'Mockup tailored to your business',
    'pricing.demo.b2': 'You can request changes',
    'pricing.demo.b3': "Don't like it — don't pay",
    'pricing.demo.cta': 'Free consultation',
    // H3: Website development (€299 one-time)
    'pricing.launch.title': 'Website development',
    'pricing.launch.price': '€299',
    'pricing.launch.period': '(one-time)',
    'pricing.launch.desc': 'If everything suits you — you get a ready-to-use website.',
    'pricing.launch.b1': 'Custom design',
    'pricing.launch.b2': 'Mobile adaptation',
    'pricing.launch.b3': 'Changes on request',
    'pricing.launch.b4': 'Lead form',
    'pricing.launch.cta': 'Free consultation',
    // How It Works - H2
    'how.title': 'How it',
    'how.titleHighlight': 'works',
    // H3 steps
    'how.step1.title': 'Tell us about your business',
    'how.step1.note': 'Takes 2 minutes — what you do and what website you need',
    'how.step2.title': 'We create a free website preview',
    'how.step2.note': 'We show the design and structure. You get a link in 1–3 days',
    'how.step3.title': 'You tell us what to change',
    'how.step3.note': 'Text, sections, style — we update everything',
    'how.step4.title': "When you're happy with it, you pay €299",
    'how.step4.note': 'Payment only after you say: "Yes, this works for me"',
    'how.step5.title': 'We connect your domain and publish the website',
    'how.step5.note': 'Your website goes live and starts collecting inquiries',
    'how.note': "If you don't like the website — you don't pay.",
    // FAQ - H2: Frequently Asked Questions
    'faq.title': 'Frequently Asked',
    'faq.titleHighlight': 'Questions',
    'faq.subtitle': 'Everything you need to know about working with our team',
    // H3 questions
    'faq.q1': 'What is a free mockup?',
    'faq.a1': "It's a preliminary version of your website before payment.",
    'faq.q2': 'When do I pay €299?',
    'faq.a2': 'Only if the mockup suits you and you want to launch the website.',
    'faq.q3': 'Can I request changes?',
    'faq.a3': 'Yes, we can make changes before launch.',
    'faq.q4': 'What do I get after payment?',
    'faq.a4': 'A ready-to-use website for your business.',
    'faq.q5': 'Do you work worldwide?',
    'faq.a5': 'Yes, we work online with clients from different countries.',
    // Testimonials - H2: What clients say
    'testimonials.title': 'Client',
    'testimonials.titleHighlight': 'Reviews',
    'testimonials.subtitle': 'What clients say about working with us',
    'testimonials.r1.name': 'Sarah',
    'testimonials.r1.text': 'I liked that they showed me the website for free first. I asked for a couple of changes, everything was fixed quickly. I paid only when everything was perfect.',
    'testimonials.r1.business': 'Beauty specialist',
    'testimonials.r2.name': 'Alex',
    'testimonials.r2.text': 'They made a clear website for my services. First they showed me the mockup, then made changes. I paid only after confirmation.',
    'testimonials.r2.business': 'Local handyman',
    'testimonials.r3.name': 'James',
    'testimonials.r3.text': "It's convenient that you don't have to pay upfront. First I looked at the website, asked to simplify the text, then paid. Everything is fair and clear.",
    'testimonials.r3.business': 'Psychologist',
    // Consultation - H2: Get your free preview
    'consultation.title': 'Order a free',
    'consultation.titleHighlight': 'consultation',
    'consultation.subtitle': "Tell us what you need — we'll send a preview link.",
    'consultation.benefit1': 'Free preview',
    'consultation.benefit2': 'Fast delivery',
    'consultation.benefit3': 'No commitment',
    'consultation.name': 'Name',
    'consultation.namePlaceholder': 'Your name',
    'consultation.email': 'Email',
    'consultation.emailPlaceholder': 'your@email.com',
    'consultation.desc': 'Project description',
    'consultation.descPlaceholder': 'Tell us about your business and what kind of website you need...',
    'consultation.cta': 'Order a free consultation',
    'consultation.note': "No commitment. If you don't like the website — you don't pay.",
    'consultation.sending': 'Sending...',
    'consultation.or': 'or talk to our team directly',
    'consultation.telegram': 'Telegram',
    'consultation.whatsapp': 'WhatsApp',
    // Footer
    'footer.services': 'Services',
    'footer.company': 'Company',
    'footer.legal': 'Legal',
    'footer.contact': 'Contact',
    'footer.rights': 'All rights reserved.',
    'footer.aboutLink': 'About Jetly',
    // Stats
    'stats.websites': 'Websites Launched',
    'stats.clients': 'Happy Clients',
    'stats.years': 'Years Experience',
    'stats.title': 'Our',
    'stats.titleHighlight': 'Impact',
    'stats.subtitle': 'Delivering results for businesses worldwide',
    // AI Course Page
    'course.hero.badge': 'Become a digital business owner',
    'course.hero.title': 'Buy a turnkey IT business: your own AI-based web studio',
    'course.hero.pill1': 'No experience needed',
    'course.hero.pill2': 'Quick ROI',
    'course.hero.pill3': 'Work for yourself',
    'course.hero.socialProof': 'students already earning with AI',
    'course.hero.socialProofCount': '100+',
    'course.hero.specialPrice': 'Price',
    'course.hero.buyCourse': 'Buy business',
    'course.recognize.title': 'Do you recognize yourself?',
    'course.recognize.c1.title': 'Working for someone else — but could work for yourself',
    'course.recognize.c1.text': "Every day you give your time and energy to someone else's business. But you still haven't started your own.",
    'course.recognize.c2.title': "Want more money — but don't know how",
    'course.recognize.c2.text': "Your salary isn't growing. Freelancing seems scary. It feels like making money online requires special knowledge.",
    'course.recognize.c3.title': "Think IT isn't for you",
    'course.recognize.c3.text': "Code, development, technology — sounds complicated. Feels like it's only for those who studied for years.",
    'course.recognize.c4.title': 'See others earning — and missing out',
    'course.recognize.c4.text': "AI has already changed the market. Those who got in early are already earning. You're still thinking.",
    'course.offer.title': 'What we offer?',
    'course.offer.tag1': 'Turnkey business',
    'course.offer.tag2': 'Suitable even for beginners',
    'course.offer.heading': 'Купить it бизнес под ключ',
    'course.offer.description': 'A system that creates websites for you. You describe the task — AI prototypes the structure, draws the design, and writes the ready code.',
    'course.offer.tagline1': 'One asset that opens a new source of income.',
    'course.offer.tagline2': 'No experience, no code — just you and AI.',
    'course.offer.feature1': 'IT agency website',
    'course.offer.feature2': 'AI agent for prototyping and design',
    'course.offer.feature3': 'AI agent for coding and layout',
    'course.offer.feature4': 'Step-by-step guide on working with the system',
    'course.offer.feature5': 'Lifetime technical support',
    'course.offer.price': '€9 500',
    'course.offer.priceLabel': '',
    'course.offer.priceDescription': 'Everything you need to start creating and selling websites.',
    'course.offer.cta': 'Buy business',
    'course.calc.title': 'How much can you earn creating websites with AI?',
    'course.calc.priceLabel': 'How much are you willing to sell a website for?',
    'course.calc.sitesLabel': 'How many websites per month do you want to make?',
    'course.calc.potentialIncome': 'YOUR POTENTIAL INCOME',
    'course.calc.perMonth': '/ month',
    'course.calc.coursePrice': 'Business price',
    'course.calc.payback': 'Payback',
    'course.calc.paybackValue': '',
    'course.calc.netProfit': 'Net profit (1st month)',
    'course.testimonials.title': 'Student reviews',
    'course.testimonials.subtitle': 'What those who have already completed the session say',
    'course.faq.title': 'Frequently asked questions',
    'course.faq.subtitle': 'Everything you need to know about the turnkey business',
    'course.faq.q1': 'Do I need experience in IT or development?',
    'course.faq.a1': 'No. The system is fully automated — you describe the task, AI does the design and code. No programming, no Figma.',
    'course.faq.q2': 'What exactly do I get after purchase?',
    'course.faq.a2': 'A ready-made agency website, two AI agents for creating design and coding, a step-by-step guide on working with the system, and lifetime technical support.',
    'course.faq.q3': 'How long does it take to create one website?',
    'course.faq.a3': 'From 30 minutes to several hours depending on complexity. AI does most of the work — you only need to check the result.',
    'course.faq.q4': 'Can I see how the system works before buying?',
    'course.faq.a4': 'Yes. Sign up for a free consultation — we will show a demo and answer all questions.',
    'course.faq.q5': 'How much can I sell websites to clients for?',
    'course.faq.a5': 'This is entirely your decision. The average market value of a single-page website is €450. There are no restrictions on our part.',
    'course.faq.q6': 'What if technical problems arise?',
    'course.faq.a6': 'We provide lifetime technical support. Write to us — we will help you figure out any issue.',
    'course.faq.q7': 'Can this business be scaled?',
    'course.faq.a7': 'Yes. The system has no limits on the number of websites. The more orders — the more income. No need to hire a team.',
    'course.fear.title1': "While you're doubting — ",
    'course.fear.title2': 'someone has already started their digital business.',
    'course.fear.f1.fear': "«I've never built websites»",
    'course.fear.f1.reality': 'Just describe what you want — AI will do everything itself',
    'course.fear.f2.fear': "«It's hard and takes a long time»",
    'course.fear.f2.reality': 'You will create your first website right after the first session',
    'course.fear.f3.fear': "«I don't know where to find clients»",
    'course.fear.f3.reality': 'Every restaurant, salon, doctor, shop — is your potential client',
    'course.fear.f4.fear': '«What if I fail»',
    'course.fear.f4.reality': "The mentor is nearby — we won't leave you until you succeed",
    'course.cta.title': 'Ready to start your business?',
    'course.cta.subtitle': 'One asset. Unlimited websites.',
    'course.cta.btn': 'Buy the business — €9 500',
    'course.cta.link': 'or book a free consultation →',
    'course.how.title': 'How it',
    'course.how.titleHighlight': 'works',
    'course.how.step1.title': 'You describe the task',
    'course.how.step1.note': 'Specify the niche, style, and what the site should do — nothing else is needed',
    'course.how.step2.title': 'AI creates the design',
    'course.how.step2.note': 'The agent generates a modern layout for your task — without Figma and a designer',
    'course.how.step3.title': 'AI codes the layout',
    'course.how.step3.note': 'The second agent turns the layout into a clean working website — automatically',
    'course.how.step4.title': 'You check the result',
    'course.how.step4.note': 'Review the site, make final edits if necessary',
    'course.how.step5.title': 'Deliver to the client — get paid',
    'course.how.step5.note': 'The client gets a ready website, you — money for the work',
    'course.testimonials.label': 'Student Reviews',
    'course.testimonials.r1.name': 'Marina',
    'course.testimonials.r1.role': 'Freelancer, Kyiv',
    'course.testimonials.r1.text': 'I thought it was hard. Built my first site in one session and already found a client. The mentor explained everything clearly, no fluff.',
    'course.testimonials.r2.name': 'Alexey',
    'course.testimonials.r2.role': 'Small Business, Warsaw',
    'course.testimonials.r2.text': 'Wanted to build sites for my business. After the session, I made a site in one evening. Paid off the course immediately — saved on a developer.',
    'course.testimonials.r3.name': 'Dmitry',
    'course.testimonials.r3.role': 'No IT experience, Berlin',
    'course.testimonials.r3.text': 'Zero programming experience. After the session, I understood how it works and now build sites for clients. Worth every cent.',
    // Sale Page
    'sale.timer.title': 'Limited time offer ends in:',
    'sale.timer.days': 'Days',
    'sale.timer.hours': 'Hours',
    'sale.timer.minutes': 'Minutes',
    'sale.timer.seconds': 'Seconds',
    'sale.hero.title': "We'll create a custom website for you",
    'sale.hero.titleHighlight': 'for FREE',
    'sale.hero.subtitle': 'Pay only €15/month for hosting and support. No upfront development costs.',
    'sale.hero.bullet1': 'Free website development',
    'sale.hero.bullet2': 'Only €15/month subscription',
    'sale.hero.bullet3': 'Cancel anytime',
    'sale.pricing.title': 'Cost of website creation',
    'sale.pricing.titleHighlight': ' ',
    'sale.pricing.subtitle': 'Get your website built for free, just pay a small monthly fee.',
    'sale.pricing.launch.title': 'Website Usage',
    'sale.pricing.launch.price': '€15',
    'sale.pricing.launch.period': '/ month',
    'sale.pricing.launch.desc': 'Everything you need to keep your website running smoothly.',
    // SMS Page
    'sms.timer.title': 'Limited time offer ends in:',
    'sms.timer.days': 'Days',
    'sms.timer.hours': 'Hours',
    'sms.timer.minutes': 'Minutes',
    'sms.timer.seconds': 'Seconds',
    'sms.hero.title': "We'll create a custom website for you",
    'sms.hero.titleHighlight': 'for FREE',
    'sms.hero.subtitle': 'Pay only 650 ₴/month for hosting and support. No upfront development costs.',
    'sms.hero.bullet1': 'Free website development',
    'sms.hero.bullet2': 'Only 650 ₴/month subscription',
    'sms.hero.bullet3': 'Cancel anytime',
    'sms.pricing.title': 'Cost of website creation',
    'sms.pricing.titleHighlight': ' ',
    'sms.pricing.subtitle': 'Get your website built for free, just pay a small monthly fee.',
    'sms.pricing.launch.title': 'Website Usage',
    'sms.pricing.launch.price': '650 ₴',
    'sms.pricing.launch.period': '/ month',
    'sms.pricing.launch.desc': 'Everything you need to keep your website running smoothly.'
  },
  ru: {
    // Navigation
    'nav.getStarted': 'Бесплатная консультация',
    'nav.home': 'Главная',
    'nav.services': 'Цены',
    'nav.howItWorks': 'Как это работает',
    'nav.referral': 'Реферальная программа',
    'nav.privacy': 'Политика конфиденциальности',
    'nav.terms': 'Условия использования',
    'nav.pricing': 'Цены',
    'nav.faq': 'Вопросы',
    'nav.testimonials': 'Отзывы',
    // Cookie Banner
    'cookie.title': 'Мы используем cookies',
    'cookie.description': 'Мы используем cookies для улучшения вашего опыта на сайте, анализа трафика и персонализации контента.',
    'cookie.accept': 'Принять все',
    'cookie.decline': 'Отклонить',
    'cookie.learnMore': 'Подробнее',
    // Hero - H1
    'hero.badge': 'Профессиональное веб-агентство',
    'hero.title': 'Сделаем индивидуальный сайт для вас',
    'hero.titleHighlight': 'всего за €299',
    'hero.subtitle': 'Покажем бесплатный макет вашего сайта. Если не понравится — вы ничего не платите.',
    'hero.bullet1': 'Бесплатное превью сайта до оплаты',
    'hero.bullet2': '€299 — стоимость разработки сайта, если вам всё подходит',
    'hero.bullet3': 'Работаем онлайн по всему миру',
    'hero.cta': 'Бесплатная консультация',
    'hero.referral': 'Реферальная программа',
    // Pricing - H2: Цены и условия
    'pricing.title': 'Цены',
    'pricing.titleHighlight': 'и условия',
    'pricing.subtitle': 'Сначала бесплатный макет. Оплата только если вам всё подходит.',
    // H3: Бесплатное демо сайта
    'pricing.demo.title': 'Бесплатный макет сайта',
    'pricing.demo.label': 'БЕСПЛАТНО',
    'pricing.demo.desc': 'Покажем ваш будущий сайт до оплаты.',
    'pricing.demo.b1': 'Макет под ваш бизнес',
    'pricing.demo.b2': 'Можно попросить правки',
    'pricing.demo.b3': 'Если не понравится — не платите',
    'pricing.demo.cta': 'Бесплатная консультация',
    // H3: Разработка сайта — €299 (разово)
    'pricing.launch.title': 'Разработка сайта',
    'pricing.launch.price': '€299',
    'pricing.launch.period': '(единоразово)',
    'pricing.launch.desc': 'Если вам всё подходит — вы получаете готовый сайт.',
    'pricing.launch.b1': 'Индивидуальный дизайн',
    'pricing.launch.b2': 'Адаптация под телефон',
    'pricing.launch.b3': 'Правки по запросу',
    'pricing.launch.b4': 'Форма заявок',
    'pricing.launch.cta': 'Бесплатная консультация',
    // How It Works - H2: Как это работает
    'how.title': 'Как это',
    'how.titleHighlight': 'работает',
    // H3 steps
    'how.step1.title': 'Расскажите о вашем бизнесе',
    'how.step1.note': 'Займёт 2 минуты — чем занимаетесь и какой сайт нужен',
    'how.step2.title': 'Мы делаем бесплатное демо сайта',
    'how.step2.note': 'Покажем дизайн и структуру. Пришлём ссылку в 1–3 дня',
    'how.step3.title': 'Вы говорите, что изменить',
    'how.step3.note': 'Текст, блоки, стиль — мы всё правим под вас',
    'how.step4.title': 'Если всё подходит — вы оплачиваете €299',
    'how.step4.note': 'Оплата только после того, как вы скажете: "Да, мне подходит"',
    'how.step5.title': 'Подключаем домен и публикуем сайт',
    'how.step5.note': 'Сайт начинает работать и принимать заявки',
    'how.note': 'Если сайт вам не понравится — вы не платите.',
    // FAQ - H2: Частые вопросы
    'faq.title': 'Частые',
    'faq.titleHighlight': 'вопросы',
    'faq.subtitle': 'Всё, что нужно знать о работе с нами',
    // H3 questions
    'faq.q1': 'Что такое бесплатный макет?',
    'faq.a1': 'Это предварительный вариант вашего сайта до оплаты.',
    'faq.q2': 'Когда я плачу €299?',
    'faq.a2': 'Только если макет вам подходит и вы хотите запускать сайт.',
    'faq.q3': 'Можно ли попросить правки?',
    'faq.a3': 'Да, мы можем внести изменения перед запуском.',
    'faq.q4': 'Что я получаю после оплаты?',
    'faq.a4': 'Готовый сайт для вашего бизнеса.',
    'faq.q5': 'Вы работаете по всему миру?',
    'faq.a5': 'Да, работаем онлайн с клиентами из разных стран.',
    // Testimonials - H2: Отзывы клиентов
    'testimonials.title': 'Отзывы',
    'testimonials.titleHighlight': 'клиентов',
    'testimonials.subtitle': 'Что говорят клиенты о работе с нами',
    'testimonials.r1.name': 'Анастасия',
    'testimonials.r1.text': 'Понравилось, что сначала мне показали сайт бесплатно. Я попросила пару правок, всё быстро исправили. Оплатила только когда всё устроило.',
    'testimonials.r1.business': 'Мастер бровей',
    'testimonials.r2.name': 'Дмитрий',
    'testimonials.r2.text': 'Мне сделали понятный сайт под мои услуги. Сначала показали макет, потом внесли правки. Оплатил только после подтверждения.',
    'testimonials.r2.business': 'Мастер по сантехнике',
    'testimonials.r3.name': 'Сергей',
    'testimonials.r3.text': 'Удобно, что не нужно платить заранее. Сначала посмотрел сайт, попросил упростить текст, после этого оплатил. Всё честно и понятно.',
    'testimonials.r3.business': 'Психолог',
    // Consultation - H2: Получить бесплатное демо
    'consultation.title': 'Заказать бесплатную',
    'consultation.titleHighlight': 'консультацию',
    'consultation.subtitle': 'Расскажите, что вам нужно — мы пришлём ссылку на превью.',
    'consultation.benefit1': 'Бесплатный просмотр',
    'consultation.benefit2': 'Быстрая доставка',
    'consultation.benefit3': 'Без обязательств',
    'consultation.name': 'Имя',
    'consultation.namePlaceholder': 'Ваше имя',
    'consultation.email': 'Email',
    'consultation.emailPlaceholder': 'ваш@email.com',
    'consultation.desc': 'Описание проекта',
    'consultation.descPlaceholder': 'Расскажите о вашем бизнесе и о том, какой сайт вам нужен…',
    'consultation.cta': 'Заказать бесплатную консультацию',
    'consultation.note': 'Без обязательств. Если сайт не понравится — вы не платите.',
    'consultation.sending': 'Отправка...',
    'consultation.or': 'или напишите нам напрямую',
    'consultation.telegram': 'Telegram',
    'consultation.whatsapp': 'WhatsApp',
    // Footer
    'footer.services': 'Услуги',
    'footer.company': 'Компания',
    'footer.legal': 'Юридическое',
    'footer.contact': 'Контакты',
    'footer.rights': 'Все права защищены.',
    'footer.aboutLink': 'О компании',
    // Stats
    'stats.websites': 'Сайтов запущено',
    'stats.clients': 'Довольных клиентов',
    'stats.years': 'Лет опыта',
    'stats.title': 'Наш',
    'stats.titleHighlight': 'Вклад',
    'stats.subtitle': 'Результаты для бизнеса по всему миру',
    // AI Course Page
    'course.hero.badge': 'Стань владельцем digital-бизнеса',
    'course.hero.title': 'Купить готовый IT-бизнес под ключ: собственная веб-студия на базе ИИ',
    'course.hero.pill1': 'Без опыта',
    'course.hero.pill2': 'Быстро окупается',
    'course.hero.pill3': 'Работай на себя',
    'course.hero.socialProof': 'уже зарабатывают с ИИ',
    'course.hero.socialProofCount': '100+ студентов',
    'course.hero.specialPrice': 'Стоимость',
    'course.hero.buyCourse': 'Купить бизнес',
    'course.recognize.title': 'Узнаёшь себя?',
    'course.recognize.c1.title': 'Работаешь на кого-то — а мог бы на себя',
    'course.recognize.c1.text': 'Каждый день отдаёшь своё время и силы чужому бизнесу. А свой — всё никак не начать.',
    'course.recognize.c2.title': 'Хочешь больше денег — но не знаешь как',
    'course.recognize.c2.text': 'Зарплата не растёт. Фриланс пугает. Кажется что для заработка в интернете нужны особые знания.',
    'course.recognize.c3.title': 'Думаешь что IT — это не для тебя',
    'course.recognize.c3.text': 'Код, разработка, технологии — звучит сложно. Кажется что это только для тех кто учился годами.',
    'course.recognize.c4.title': 'Видишь как другие зарабатывают — и упускаешь время',
    'course.recognize.c4.text': 'ИИ уже изменил рынок. Те кто зашёл раньше — уже зарабатывают. Ты всё ещё думаешь.',
    'course.offer.title': 'Что мы предлагаем?',
    'course.offer.tag1': 'Готовый бизнес',
    'course.offer.tag2': 'Подходит даже для новичков',
    'course.offer.heading': 'Купить it бизнес под ключ',
    'course.offer.description': 'Система, которая создает сайты вместо тебя. Ты описываешь задачу — ИИ сам прототипирует структуру, рисует дизайн и верстает готовый код.',
    'course.offer.tagline1': 'Один актив, который открывает новый источник дохода.',
    'course.offer.tagline2': 'Без опыта, без кода — просто ты и ИИ.',
    'course.offer.feature1': 'Сайт IT агентства',
    'course.offer.feature2': 'ИИ-агент прототипирования и дизайна',
    'course.offer.feature3': 'ИИ-агент верстки и написания кода',
    'course.offer.feature4': 'Пошаговый гайд по работе с системой',
    'course.offer.feature5': 'Пожизненная техническая поддержка',
    'course.offer.price': '€9 500',
    'course.offer.priceLabel': '',
    'course.offer.priceDescription': 'Всё, что нужно, чтобы начать создавать и продавать сайты.',
    'course.offer.cta': 'Купить бизнес',
    'course.calc.title': 'Сколько можно заработать на создании сайтов с помощью ИИ?',
    'course.calc.priceLabel': 'За сколько ты готов продать сайт?',
    'course.calc.sitesLabel': 'Сколько сайтов в месяц ты хочешь делать?',
    'course.calc.potentialIncome': 'ТВОЙ ПОТЕНЦИАЛЬНЫЙ ДОХОД',
    'course.calc.perMonth': '/ мес',
    'course.calc.coursePrice': 'Стоимость бизнеса',
    'course.calc.payback': 'Окупаемость',
    'course.calc.paybackValue': '',
    'course.calc.netProfit': 'Чистая прибыль (1-й мес)',
    'course.faq.title': 'Частые вопросы',
    'course.faq.subtitle': 'Всё, что нужно знать о готовом бизнесе',
    'course.faq.q1': 'Нужен ли опыт в IT или разработке?',
    'course.faq.a1': 'Нет. Система полностью автоматизирована — ты описываешь задачу, ИИ делает дизайн и код. Никакого программирования, никакого Figma.',
    'course.faq.q2': 'Что конкретно я получаю после покупки?',
    'course.faq.a2': 'Готовый сайт агентства, два ИИ-агента для создания дизайна и верстки кода, пошаговый гайд по работе с системой и пожизненную техническую поддержку.',
    'course.faq.q3': 'Сколько времени занимает создание одного сайта?',
    'course.faq.a3': 'От 30 минут до нескольких часов в зависимости от сложности. Большую часть работы выполняет ИИ — тебе остается только проверить результат.',
    'course.faq.q4': 'Можно ли увидеть как работает система до покупки?',
    'course.faq.a4': 'Да. Запишись на бесплатную консультацию — мы покажем демо и ответим на все вопросы.',
    'course.faq.q5': 'За сколько я могу продавать сайты клиентам?',
    'course.faq.a5': 'Это полностью твое решение. Средняя рыночная стоимость одностраничного сайта — €450. Никаких ограничений с нашей стороны нет.',
    'course.faq.q6': 'Что если возникнут технические проблемы?',
    'course.faq.a6': 'Мы предоставляем пожизненную техническую поддержку. Напишешь нам — поможем разобраться с любым вопросом.',
    'course.faq.q7': 'Можно ли масштабировать этот бизнес?',
    'course.faq.a7': 'Да. Система не имеет ограничений по количеству сайтов. Чем больше заказов — тем больше доход. Нанимать команду не нужно.',
    'course.fear.title1': 'Пока ты сомневаешься — ',
    'course.fear.title2': 'кто-то уже открыл свой digital-бизнес.',
    'course.fear.f1.fear': '«Я никогда не делал сайты»',
    'course.fear.f1.reality': 'Просто опиши что хочешь — ИИ сделает всё сам',
    'course.fear.f2.fear': '«Это сложно и долго»',
    'course.fear.f2.reality': 'Ты создашь первый сайт прямо после первого занятия',
    'course.fear.f3.fear': '«Не знаю где брать клиентов»',
    'course.fear.f3.reality': 'Каждый ресторан, салон, врач, магазин — твой потенциальный клиент',
    'course.fear.f4.fear': '«А вдруг не получится»',
    'course.fear.f4.reality': 'Ментор рядом — не бросим пока не получится',
    'course.cta.title': 'Готовы начать бизнес?',
    'course.cta.subtitle': 'Один актив. Неограниченное количество сайтов.',
    'course.cta.btn': 'Купить бизнес — €9 500',
    'course.cta.link': 'или записаться на бесплатную консультацию →',
    'course.how.title': 'Как это',
    'course.how.titleHighlight': 'работает',
    'course.how.step1.title': 'Ты описываешь задачу',
    'course.how.step1.note': 'Указываешь нишу, стиль и что должен делать сайт — больше ничего не нужно',
    'course.how.step2.title': 'ИИ создает дизайн',
    'course.how.step2.note': 'Агент генерирует современный макет под твою задачу — без Figma и дизайнера',
    'course.how.step3.title': 'ИИ верстает готовый код',
    'course.how.step3.note': 'Второй агент превращает макет в чистый рабочий сайт — автоматически',
    'course.how.step4.title': 'Ты проверяешь результат',
    'course.how.step4.note': 'Просматриваешь сайт, вносишь финальные правки если нужно',
    'course.how.step5.title': 'Сдаешь клиенту — получаешь оплату',
    'course.how.step5.note': 'Клиент получает готовый сайт, ты — деньги за работу',
    'course.testimonials.label': 'Отзывы студентов',
    'course.testimonials.r1.name': 'Марина',
    'course.testimonials.r1.role': 'Фрилансер, Киев',
    'course.testimonials.r1.text': 'Думала, что это сложно. За одну сессию сделала первый сайт — и уже нашла клиента. Ментор объяснял всё понятно, без воды.',
    'course.testimonials.r2.name': 'Алексей',
    'course.testimonials.r2.role': 'Малый бизнес, Варшава',
    'course.testimonials.r2.text': 'Хотел сам делать сайты для своего бизнеса. После сессии сделал сайт за вечер. Окупил курс сразу — сэкономил на разработчике.',
    'course.testimonials.r3.name': 'Дмитрий',
    'course.testimonials.r3.role': 'Без опыта в IT, Берлин',
    'course.testimonials.r3.text': 'Ноль опыта в программировании. После сессии понял как всё работает и уже делаю сайты на заказ. Стоит каждого цента.',
    // Sale Page
    'sale.timer.title': 'Специальное предложение заканчивается через:',
    'sale.timer.days': 'Дней',
    'sale.timer.hours': 'Часов',
    'sale.timer.minutes': 'Минут',
    'sale.timer.seconds': 'Секунд',
    'sale.hero.title': 'Сделаем индивидуальный сайт для вас',
    'sale.hero.titleHighlight': 'БЕСПЛАТНО',
    'sale.hero.subtitle': 'Платите только €15 в месяц за поддержку. Никаких скрытых платежей за разработку.',
    'sale.hero.bullet1': 'Бесплатная разработка сайта',
    'sale.hero.bullet2': 'Всего €15/мес за обслуживание',
    'sale.hero.bullet3': 'Отмена в любой момент',
    'sale.pricing.title': 'Стоимость создания сайта',
    'sale.pricing.titleHighlight': ' ',
    'sale.pricing.subtitle': 'Получите готовый сайт бесплатно, оплачивая только небольшую подписку.',
    'sale.pricing.launch.title': 'Использование сайта',
    'sale.pricing.launch.price': '€15',
    'sale.pricing.launch.period': '/ мес',
    'sale.pricing.launch.desc': 'Всё необходимое для бесперебойной работы вашего сайта.',
    // SMS Page
    'sms.timer.title': 'Специальное предложение заканчивается через:',
    'sms.timer.days': 'Дней',
    'sms.timer.hours': 'Часов',
    'sms.timer.minutes': 'Минут',
    'sms.timer.seconds': 'Секунд',
    'sms.hero.title': 'Сделаем индивидуальный сайт для вас',
    'sms.hero.titleHighlight': 'БЕСПЛАТНО',
    'sms.hero.subtitle': 'Платите только 650 ₴ в месяц за поддержку. Никаких скрытых платежей за разработку.',
    'sms.hero.bullet1': 'Бесплатная разработка сайта',
    'sms.hero.bullet2': 'Всего 650 ₴/мес за обслуживание',
    'sms.hero.bullet3': 'Отмена в любой момент',
    'sms.pricing.title': 'Стоимость создания сайта',
    'sms.pricing.titleHighlight': ' ',
    'sms.pricing.subtitle': 'Получите готовый сайт бесплатно, оплачивая только небольшую подписку.',
    'sms.pricing.launch.title': 'Использование сайта',
    'sms.pricing.launch.price': '650 ₴',
    'sms.pricing.launch.period': '/ мес',
    'sms.pricing.launch.desc': 'Всё необходимое для бесперебойной работы вашего сайта.'
  },
  ua: {
    // Navigation
    'nav.getStarted': 'Безкоштовна консультація',
    'nav.home': 'Головна',
    'nav.services': 'Ціни',
    'nav.howItWorks': 'Як це працює',
    'nav.referral': 'Реферальна програма',
    'nav.privacy': 'Політика конфіденційності',
    'nav.terms': 'Умови використання',
    'nav.pricing': 'Ціни',
    'nav.faq': 'Питання',
    'nav.testimonials': 'Відгуки',
    // Cookie Banner
    'cookie.title': 'Ми використовуємо cookies',
    'cookie.description': 'Ми використовуємо cookies для покращення вашого досвіду на сайті, аналізу трафіку та персоналізації контенту.',
    'cookie.accept': 'Прийняти все',
    'cookie.decline': 'Відхилити',
    'cookie.learnMore': 'Детальніше',
    // Hero - H1
    'hero.badge': 'Професійне веб-агентство',
    'hero.title': 'Зробимо індивідуальний сайт для вас',
    'hero.titleHighlight': 'всього за €299',
    'hero.subtitle': 'Покажемо безкоштовний макет вашого сайту. Якщо не сподобається — ви нічого не платите.',
    'hero.bullet1': "Безкоштовне прев'ю сайту до оплати",
    'hero.bullet2': '€299 — вартість розробки сайту, якщо вам усе підходить',
    'hero.bullet3': 'Працюємо онлайн по всьому світу',
    'hero.cta': 'Безкоштовна консультація',
    'hero.referral': 'Реферальна програма',
    // Pricing - H2: Ціни та умови
    'pricing.title': 'Ціни',
    'pricing.titleHighlight': 'та умови',
    'pricing.subtitle': 'Спочатку безкоштовний макет. Оплата тільки якщо вам усе підходить.',
    // H3: Безкоштовне демо сайту
    'pricing.demo.title': 'Безкоштовний макет сайту',
    'pricing.demo.label': 'БЕЗКОШТОВНО',
    'pricing.demo.desc': 'Покажемо ваш майбутній сайт до оплати.',
    'pricing.demo.b1': 'Макет під ваш бізнес',
    'pricing.demo.b2': 'Можна попросити правки',
    'pricing.demo.b3': 'Якщо не сподобається — не платите',
    'pricing.demo.cta': 'Безкоштовна консультація',
    // H3: Розробка сайту — €299 (разово)
    'pricing.launch.title': 'Розробка сайту',
    'pricing.launch.price': '€299',
    'pricing.launch.period': '(разово)',
    'pricing.launch.desc': 'Якщо вам усе підходить — ви отримуєте готовий сайт.',
    'pricing.launch.b1': 'Індивідуальний дизайн',
    'pricing.launch.b2': 'Адаптація під телефон',
    'pricing.launch.b3': 'Правки за запитом',
    'pricing.launch.b4': 'Форма заявок',
    'pricing.launch.cta': 'Безкоштовна консультація',
    // How It Works - H2: Як це працює
    'how.title': 'Як це',
    'how.titleHighlight': 'працює',
    // H3 steps
    'how.step1.title': 'Розкажіть про ваш бізнес',
    'how.step1.note': 'Займе 2 хвилини — чим займаєтесь і який сайт потрібен',
    'how.step2.title': 'Ми робимо безкоштовне демо сайту',
    'how.step2.note': 'Покажемо дизайн і структуру. Надішлемо посилання за 1–3 дні',
    'how.step3.title': 'Ви кажете, що змінити',
    'how.step3.note': 'Текст, блоки, стиль — ми все підправляємо під вас',
    'how.step4.title': 'Якщо все підходить — ви сплачуєте €299',
    'how.step4.note': 'Оплата тільки після того, як ви скажете: "Так, мені підходить"',
    'how.step5.title': 'Підключаємо домен і публікуємо сайт',
    'how.step5.note': 'Сайт починає працювати та приймати заявки',
    'how.note': 'Якщо сайт вам не сподобається — ви не платите.',
    // FAQ - H2: Поширені запитання
    'faq.title': 'Поширені',
    'faq.titleHighlight': 'запитання',
    'faq.subtitle': 'Все, що потрібно знати про роботу з нами',
    // H3 questions
    'faq.q1': 'Що таке безкоштовний макет?',
    'faq.a1': 'Це попередній варіант вашого сайту до оплати.',
    'faq.q2': 'Коли я сплачую €299?',
    'faq.a2': 'Тільки якщо макет вам підходить і ви хочете запускати сайт.',
    'faq.q3': 'Чи можна попросити правки?',
    'faq.a3': 'Так, ми можемо внести зміни перед запуском.',
    'faq.q4': 'Що я отримаю після оплати?',
    'faq.a4': 'Готовий сайт для вашого бізнесу.',
    'faq.q5': 'Ви працюєте по всьому світу?',
    'faq.a5': 'Так, працюємо онлайн з клієнтами з різних країн.',
    // Testimonials - H2: Відгуки клієнтів
    'testimonials.title': 'Відгуки',
    'testimonials.titleHighlight': 'клієнтів',
    'testimonials.subtitle': 'Що кажуть клієнти про роботу з нами',
    'testimonials.r1.name': 'Оксана',
    'testimonials.r1.text': 'Сподобалося, що спочатку мені показали сайт безкоштовно. Я попросила пару правок, все швидко виправили. Оплатила тільки коли все влаштувало.',
    'testimonials.r1.business': 'Майстер манікюру',
    'testimonials.r2.name': 'Віталій',
    'testimonials.r2.text': 'Мені зробили зрозумілий сайт під мої послуги. Спочатку показали макет, потім внесли правки. Оплатив тільки після підтвердження.',
    'testimonials.r2.business': 'Ремонт техніки',
    'testimonials.r3.name': 'Андрій',
    'testimonials.r3.text': 'Зручно, що не потрібно платити заздалегідь. Спочатку подивився сайт, попросив спростити текст, після цього оплатив. Все чесно і зрозуміло.',
    'testimonials.r3.business': 'Юрист',
    // Consultation - H2: Отримати безкоштовне демо
    'consultation.title': 'Замовити безкоштовну',
    'consultation.titleHighlight': 'консультацію',
    'consultation.subtitle': "Скажіть, що вам потрібно — ми надішлемо посилання на прев'ю.",
    'consultation.benefit1': 'Безкоштовний перегляд',
    'consultation.benefit2': 'Швидка доставка',
    'consultation.benefit3': "Без зобов'язань",
    'consultation.name': "Ім'я",
    'consultation.namePlaceholder': "Ваше ім'я",
    'consultation.email': 'Email',
    'consultation.emailPlaceholder': 'ваш@email.com',
    'consultation.desc': 'Опис проєкту',
    'consultation.descPlaceholder': 'Розкажіть про ваш бізнес і який сайт вам потрібен...',
    'consultation.cta': 'Замовити безкоштовну консультацію',
    'consultation.note': "Без зобов'язань. Якщо сайт не сподобається — ви не платите.",
    'consultation.sending': 'Відправка...',
    'consultation.or': 'або напишіть нам напряму',
    'consultation.telegram': 'Telegram',
    'consultation.whatsapp': 'WhatsApp',
    // Footer
    'footer.services': 'Послуги',
    'footer.company': 'Компанія',
    'footer.legal': 'Юридичне',
    'footer.contact': 'Контакти',
    'footer.rights': 'Всі права захищені.',
    'footer.aboutLink': 'Про нас',
    // Stats
    'stats.websites': 'Сайтів запущено',
    'stats.clients': 'Задоволених клієнтів',
    'stats.years': 'Років досвіду',
    'stats.title': 'Наш',
    'stats.titleHighlight': 'Вплив',
    'stats.subtitle': 'Результати для бізнесу по всьому світу',
    // AI Course Page
    'course.hero.badge': 'Стань власником digital-бізнесу',
    'course.hero.title': 'Купити готовий IT-бізнес під ключ: власна веб-студія на базі ШІ',
    'course.hero.pill1': 'Без досвіду',
    'course.hero.pill2': 'Швидко окупається',
    'course.hero.pill3': 'Працюй на себе',
    'course.hero.socialProof': 'вже заробляють з ШІ',
    'course.hero.socialProofCount': '100+ студентів',
    'course.hero.specialPrice': 'Вартість',
    'course.hero.buyCourse': 'Купити бізнес',
    'course.recognize.title': 'Впізнаєш себе?',
    'course.recognize.c1.title': 'Працюєш на когось — а міг би на себе',
    'course.recognize.c1.text': 'Кожен день віддаєш свій час і сили чужому бізнесу. А свій — все ніяк не почати.',
    'course.recognize.c2.title': 'Хочеш більше грошей — але не знаєш як',
    'course.recognize.c2.text': 'Зарплата не росте. Фріланс лякає. Здається, що для заробітку в інтернеті потрібні особливі знання.',
    'course.recognize.c3.title': 'Думаєш що IT — це не для тебе',
    'course.recognize.c3.text': 'Код, розробка, технології — звучить складно. Здається, що це тільки для тих, хто вчився роками.',
    'course.recognize.c4.title': 'Бачиш як інші заробляють — і втрачаєш час',
    'course.recognize.c4.text': 'ШІ вже змінив ринок. Ті, хто зайшов раніше — вже заробляють. Ти все ще думаєш.',
    'course.offer.title': 'Що ми пропонуємо?',
    'course.offer.tag1': 'Готовий бізнес',
    'course.offer.tag2': 'Підходить навіть для новачків',
    'course.offer.heading': 'Купить it бизнес под ключ',
    'course.offer.description': 'Система, яка створює сайти замість тебе. Ти описуєш задачу — ШІ сам прототипує структуру, малює дизайн і верстає готовий код.',
    'course.offer.tagline1': 'Один актив, який відкриває нове джерело доходу.',
    'course.offer.tagline2': 'Без досвіду, без коду — просто ти і ШІ.',
    'course.offer.feature1': 'Сайт IT агенції',
    'course.offer.feature2': 'ШІ-агент прототипування та дизайну',
    'course.offer.feature3': 'ШІ-агент верстки і написання коду',
    'course.offer.feature4': 'Покроковий гайд по роботі з системою',
    'course.offer.feature5': 'Довічна технічна підтримка',
    'course.offer.price': '€9 500',
    'course.offer.priceLabel': '',
    'course.offer.priceDescription': 'Все, що потрібно, щоб почати створювати і продавати сайти.',
    'course.offer.cta': 'Купити бізнес',
    'course.calc.title': 'Скільки можна заробити на створенні сайтів за допомогою ШІ?',
    'course.calc.priceLabel': 'За скільки ти готовий продати сайт?',
    'course.calc.sitesLabel': 'Скільки сайтів на місяць ти хочеш робити?',
    'course.calc.potentialIncome': 'ТВІЙ ПОТЕНЦІЙНИЙ ДОХІД',
    'course.calc.perMonth': '/ міс',
    'course.calc.coursePrice': 'Вартість бізнесу',
    'course.calc.payback': 'Окупність',
    'course.calc.paybackValue': '',
    'course.calc.netProfit': 'Чистий прибуток (1-й міс)',
    'course.faq.title': 'Часті питання',
    'course.faq.subtitle': 'Все, що потрібно знати про готовий бізнес',
    'course.faq.q1': 'Чи потрібен досвід в IT або розробці?',
    'course.faq.a1': 'Ні. Система повністю автоматизована — ти описуєш задачу, ШІ робить дизайн і код. Жодного програмування, жодного Figma.',
    'course.faq.q2': 'Що конкретно я отримую після покупки?',
    'course.faq.a2': 'Готовий сайт агентства, два ШІ-агенти для створення дизайну і верстки коду, покроковий гайд по роботі з системою та довічну технічну підтримку.',
    'course.faq.q3': 'Скільки часу займає створення одного сайту?',
    'course.faq.a3': 'Від 30 хвилин до кількох годин залежно від складності. Більшу частину роботи виконує ШІ — тобі залишається тільки перевірити результат.',
    'course.faq.q4': 'Чи можна побачити як працює система до покупки?',
    'course.faq.a4': 'Так. Запишися на безкоштовну консультацію — ми покажемо демо і відповімо на всі питання.',
    'course.faq.q5': 'За скільки я можу продавати сайти клієнтам?',
    'course.faq.a5': 'Це повністю твоє рішення. Середня ринкова вартість односторінкового сайту — €450. Ніяких обмежень з нашого боку немає.',
    'course.faq.q6': 'Що якщо виникнуть технічні проблеми?',
    'course.faq.a6': 'Ми надаємо довічну технічну підтримку. Напишеш нам — допоможемо розібратися з будь-яким питанням.',
    'course.faq.q7': 'Чи можна масштабувати цей бізнес?',
    'course.faq.a7': 'Так. Система не має обмежень по кількості сайтів. Чим більше замовлень — тим більший дохід. Наймати команду не потрібно.',
    'course.fear.title1': 'Поки ти сумніваєшся — ',
    'course.fear.title2': 'хтось вже відкрив свій digital-бізнес.',
    'course.fear.f1.fear': '«Я ніколи не робив сайти»',
    'course.fear.f1.reality': 'Просто опиши що хочеш — ШІ зробить все сам',
    'course.fear.f2.fear': '«Це складно і довго»',
    'course.fear.f2.reality': 'Ти створиш перший сайт прямо після першого заняття',
    'course.fear.f3.fear': '«Не знаю де брати клієнтів»',
    'course.fear.f3.reality': 'Кожен ресторан, салон, лікар, магазин — твій потенційний клієнт',
    'course.fear.f4.fear': '«А раптом не вийде»',
    'course.fear.f4.reality': 'Ментор поруч — не кинемо поки не вийде',
    'course.cta.title': 'Готові почати бізнес?',
    'course.cta.subtitle': 'Один актив. Необмежена кількість сайтів.',
    'course.cta.btn': 'Купити бізнес — €9 500',
    'course.cta.link': 'або записатися на безкоштовну консультацію →',
    'course.how.title': 'Як це',
    'course.how.titleHighlight': 'працює',
    'course.how.step1.title': 'Ти описуєш задачу',
    'course.how.step1.note': 'Вказуєш нішу, стиль і що має робити сайт — більше нічого не потрібно',
    'course.how.step2.title': 'ШІ створює дизайн',
    'course.how.step2.note': 'Агент генерує сучасний макет під твою задачу — без Figma і дизайнера',
    'course.how.step3.title': 'ШІ верстає готовий код',
    'course.how.step3.note': 'Другий агент перетворює макет у чистий робочий сайт — автоматично',
    'course.how.step4.title': 'Ти перевіряєш результат',
    'course.how.step4.note': 'Переглядаєш сайт, вносиш фінальні правки якщо потрібно',
    'course.how.step5.title': 'Здаєш клієнту — отримуєш оплату',
    'course.how.step5.note': 'Клієнт отримує готовий сайт, ти — гроші за роботу',
    'course.testimonials.label': 'Відгуки студентів',
    'course.testimonials.r1.name': 'Марина',
    'course.testimonials.r1.role': 'Фрілансер, Київ',
    'course.testimonials.r1.text': 'Думала, що це складно. За одну сесію зробила перший сайт — і вже знайшла клієнта. Ментор пояснював все зрозуміло, без води.',
    'course.testimonials.r2.name': 'Олексій',
    'course.testimonials.r2.role': 'Малий бізнес, Варшава',
    'course.testimonials.r2.text': 'Хотів сам робити сайти для свого бізнесу. Після сесії зробив сайт за вечір. Окупив курс відразу — заощадив на розробнику.',
    'course.testimonials.r3.name': 'Дмитро',
    'course.testimonials.r3.role': 'Без досвіду в IT, Берлин',
    'course.testimonials.r3.text': 'Нуль досвіду в програмуванні. Після сесії зрозумів як все працює і вже роблю сайти на замовлення. Вартує кожного цента.',
    // Sale Page
    'sale.timer.title': 'Спеціальна пропозиція закінчується через:',
    'sale.timer.days': 'Днів',
    'sale.timer.hours': 'Годин',
    'sale.timer.minutes': 'Хвилин',
    'sale.timer.seconds': 'Секунд',
    'sale.hero.title': 'Зробимо індивідуальний сайт для вас',
    'sale.hero.titleHighlight': 'БЕЗКОШТОВНО',
    'sale.hero.subtitle': 'Платіть лише €15 на місяць за підтримку. Жодних прихованих платежів за розробку.',
    'sale.hero.bullet1': 'Безкоштовна розробка сайту',
    'sale.hero.bullet2': 'Всього €15/міс за обслуговування',
    'sale.hero.bullet3': 'Скасування в будь-який момент',
    'sale.pricing.title': 'Вартість створення сайту',
    'sale.pricing.titleHighlight': ' ',
    'sale.pricing.subtitle': 'Отримайте готовий сайт безкоштовно, сплачуючи лише невелику підписку.',
    'sale.pricing.launch.title': 'Використання сайту',
    'sale.pricing.launch.price': '€15',
    'sale.pricing.launch.period': '/ міс',
    'sale.pricing.launch.desc': 'Все необхідне для безперебійної роботи вашого сайту.',
    // SMS Page
    'sms.timer.title': 'Спеціальна пропозиція закінчується через:',
    'sms.timer.days': 'Днів',
    'sms.timer.hours': 'Годин',
    'sms.timer.minutes': 'Хвилин',
    'sms.timer.seconds': 'Секунд',
    'sms.hero.title': 'Зробимо індивідуальний сайт для вас',
    'sms.hero.titleHighlight': 'БЕЗКОШТОВНО',
    'sms.hero.subtitle': 'Платіть лише 650 ₴ на місяць за підтримку. Жодних прихованих платежів за розробку.',
    'sms.hero.bullet1': 'Безкоштовна розробка сайту',
    'sms.hero.bullet2': 'Всього 650 ₴/міс за обслуговування',
    'sms.hero.bullet3': 'Скасування в будь-який момент',
    'sms.pricing.title': 'Вартість створення сайту',
    'sms.pricing.titleHighlight': ' ',
    'sms.pricing.subtitle': 'Отримайте готовий сайт безкоштовно, сплачуючи лише невелику підписку.',
    'sms.pricing.launch.title': 'Використання сайту',
    'sms.pricing.launch.price': '650 ₴',
    'sms.pricing.launch.period': '/ міс',
    'sms.pricing.launch.desc': 'Все необхідне для безперебійної роботи вашого сайту.'
  }
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('cz');
  useEffect(() => {
    const updateLanguageFromPath = () => {
      const path = window.location.pathname;
      if (path.startsWith('/ru')) {
        setLanguage('ru');
      } else if (path.startsWith('/ua') || path.startsWith('/uk')) {
        setLanguage('ua');
      } else if (path.startsWith('/en')) {
        setLanguage('en');
      } else {
        setLanguage('cz');
      }
    };
    // Initial check
    updateLanguageFromPath();
    // Listen for client-side navigation
    window.addEventListener('popstate', updateLanguageFromPath);
    return () => window.removeEventListener('popstate', updateLanguageFromPath);
  }, []);
  const t = (key: string): string => {
    return translations[language][key as keyof (typeof translations)['en']] || key;
  };
  const getPath = (path: string): string => {
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    if (language === 'ru') {
      return `/ru/${cleanPath}`;
    } else if (language === 'ua') {
      return `/ua/${cleanPath}`;
    } else if (language === 'en') {
      return `/en/${cleanPath}`;
    }
    return `/${cleanPath}`;
  };
  const navigate = (path: string) => {
    // If it's just a hash link on the same page
    if (path.startsWith('#')) {
      const element = document.querySelector(path);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
      return;
    }
    // Otherwise, it's a page navigation
    const fullPath = getPath(path);
    // Check if we are navigating to a hash on a different page
    const [pagePath, hash] = fullPath.split('#');
    window.history.pushState({}, '', pagePath);
    window.dispatchEvent(new Event('popstate'));
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t,
    getPath,
    navigate
  }} data-id="element-533">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}